import type { LucideIcon } from 'lucide-react';
import { cn } from '../../lib/utils';

type Tone = 'blue' | 'green' | 'amber' | 'violet' | 'rose';

// dark: variants ADDED FOR THEME
const tones: Record<Tone, string> = {
  blue: 'bg-blue-50 text-blue-600 dark:bg-blue-500/15 dark:text-blue-400',
  green: 'bg-emerald-50 text-emerald-600 dark:bg-emerald-500/15 dark:text-emerald-400',
  amber: 'bg-amber-50 text-amber-600 dark:bg-amber-500/15 dark:text-amber-400',
  violet: 'bg-violet-50 text-violet-600 dark:bg-violet-500/15 dark:text-violet-400',
  rose: 'bg-rose-50 text-rose-600 dark:bg-rose-500/15 dark:text-rose-400',
};

export function StatCard({
  label,
  value,
  icon: Icon,
  tone = 'blue',
  delta,
}: {
  label: string;
  value: string | number;
  icon: LucideIcon;
  tone?: Tone;
  delta?: string;
}) {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-5 text-left shadow-sm dark:border-gray-800 dark:bg-gray-900"> {/* dark: ADDED FOR THEME */}
      <div className="flex items-center justify-between">
        <span className={cn('rounded-xl p-2.5', tones[tone])}>
          <Icon className="h-5 w-5" />
        </span>
        {delta && <span className="text-xs font-semibold text-emerald-600 dark:text-emerald-400">{delta}</span>}
      </div>
      <p className="mt-4 text-2xl font-bold text-gray-900 dark:text-gray-100">{value}</p>
      <p className="text-sm text-gray-500 dark:text-gray-400">{label}</p>
    </div>
  );
}
